import EmblaCarousel from "embla-carousel";

document.addEventListener("DOMContentLoaded", async () => {
  const emblaContainer = document.querySelector(".embla-related");

  if (!emblaContainer) return;

  const viewportNode = emblaContainer.querySelector(".embla__viewport-related");

  const base = emblaContainer.dataset.url;
  const url = new URL(base, window.location.origin);
  url.searchParams.set("product_id", emblaContainer.dataset.productId);
  url.searchParams.set("intent", emblaContainer.dataset.intent);
  url.searchParams.set("limit", emblaContainer.dataset.limit);
  url.searchParams.set("section_id", "related-products");

  const show = () => {
    emblaContainer.closest('section').hidden = false;
  }

  if (emblaContainer.dataset.emblaInitialized) return;
  if (!viewportNode) return;

  try {
    const res = await fetch(url.toString(), {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    if (!res.ok) {
      console.warn("[ProductRecommendations] Fetch fallita:", res.status);
      return;
    }

    const wrapper = doc.querySelector(".embla__container-related");

    viewportNode.appendChild(wrapper);
  } catch {
    console.error("[ProductRecommendations] Errore:", err);
  }

  const totalSlide = viewportNode.querySelectorAll(
    ":scope .embla__slide",
  ).length;
  const cards = document.querySelectorAll("product-card");

  if (totalSlide <= 1) {
    return;
  }
  else {
    show();
  }

  emblaContainer.emblaApi = EmblaCarousel(viewportNode, {
    loop: true,
    align: "start",
    breakpoints: {
      "(min-width: 768px)": {
        active: false,
      },
    },
  });

  emblaContainer.emblaApi.on("pointerDown", () => {
    cards.forEach((card) => {
      const api = card.emblaApi;
      if (api) {
        api.reInit({ draggable: false });
      }
    });
  });

  emblaContainer.emblaApi.on("pointerUp", () => {
    cards.forEach((card) => {
      const api = card.emblaApi;
      if (api) {
        api.reInit({ draggable: true });
      }
    });
  });

  emblaContainer.dataset.emblaInitialized = "true";
});
